import React from "react";
import OrderPills from "../../../../../atoms/Pills/OrderPills";
import { ParseDate, ParseDateTime } from "../../../../../../../helpers/Parsers";

import styles from "./TableItemMobile.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";
export const RequestOrderItemMobile = ({ requestOrder, handleClick }) => {
  const prueba = (e) => {
    handleClick(e);
  };
  return (
    <div
      className={styles["request-order-table-item-mobile-container"]}
      data-automation-id="request-order-table-item"
      data-requestorder-id={requestOrder.id}
      onClick={prueba}
    >
      <div className={styles["request-order-table-item-mobile-code"]}>
        Nro {requestOrder.code}
      </div>

      <div className={styles["request-order-table-item-mobile-date"]}>
        {i18n.t("date")}: {ParseDate(requestOrder.created_at)}
      </div>

      <div className={styles["request-order-table-item-mobile-bottom"]}>
        <div className={styles["request-order-table-item-mobile-owner"]}>
          {capitalize(i18n.t("owner"))}:{" "}
          {requestOrder.owner
            ? `${requestOrder.owner.first_name} ${requestOrder.owner.last_name}`
            : "-"}
        </div>
        <div className={styles["request-order-table-item-mobile-state-inner"]}>
          <OrderPills state={requestOrder.status}></OrderPills>
        </div>
      </div>
    </div>
  );
};

export default RequestOrderItemMobile;
